export const DEFAULT_ERROR = {
  type: '',
  reason: {},
};
